import { MMKV } from 'react-native-mmkv';
import RemoteConfig from './RemoteConfig';
import { CLEAR_CACHE_TYPES, REMOTE_CONFIG_KEYS } from '../config/Constants';
import { jsonParser } from './JsonUtility';
import { setCacheApiKeys } from '../actions/ActionTypes';
import { getStoreRef } from '../store/StoreUtility';
import { isBlank } from './BooleanUtility';

// Initialize MMKV
export const storage = new MMKV();

export const getCachedData = (key, type, disableExpiryValidation = false) => {
  const resetApiDataCacheSchedule =
    jsonParser(RemoteConfig.getValue(REMOTE_CONFIG_KEYS.reset_api_data_cache_schedule)) || {};
  const resetCacheHour = resetApiDataCacheSchedule[type];
  const cachedItem = storage.getString(key);
  if (!cachedItem) return null; // No cached data found

  const { data, timestamp } = JSON.parse(cachedItem);

  // Check if 12 hours have passed
  const TWELVE_HOURS = resetCacheHour * 60 * 60 * 1000; // 12 hours in milliseconds
  const isCacheExpired = Date.now() - timestamp > TWELVE_HOURS;

  if (!disableExpiryValidation && isCacheExpired) {
    storage.delete(key); // Clear expired cache
    return null;
  }
  return data; // Return cached data if not expired
};

export const cacheData = (key, data, type) => {
  getStoreRef().dispatch(setCacheApiKeys(key, type));
  storage.set(key, JSON.stringify({ data, timestamp: Date.now() }));
};

export const clearAllCacheData = () => {
  const getCachedKeys = getStoreRef().getState()?.UserAccountInfo?.cachedApiKeys;

  if (isBlank(getCachedKeys)) return;

  CLEAR_CACHE_TYPES.forEach((type) => {
    if (getCachedKeys[type]) {
      if (isBlank(getCachedKeys[type])) return;
      getCachedKeys[type].forEach((key) => {
        clearIndividualCache(key); // Remove each key from storage
      });
    }
  });

  console.tron.log('Cleared cache for types:', CLEAR_CACHE_TYPES);
};

export const clearIndividualCache = (key) => {
  storage.delete(key);
};
